import { createContext } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var CardContext = /*#__PURE__*/createContext({
  hiddenPrice: false
});
CardContext.displayName = "CardContext";
export function CardContextProvider(_ref) {
  var _ref$hiddenPrice = _ref.hiddenPrice,
      hiddenPrice = _ref$hiddenPrice === void 0 ? false : _ref$hiddenPrice,
      children = _ref.children;
  return /*#__PURE__*/_jsx(CardContext.Provider, {
    value: {
      hiddenPrice: hiddenPrice
    },
    children: children
  });
}